import repository from 'client/repository';
import asyncBuilder from 'utilities/actions';
import alertActions from 'areas/alert/actions';

const sendCode = asyncBuilder(
    'SEND_CODE',
    (qrCode, sendByEmail, sendBySMS) => repository.auth.sendCode(qrCode, sendByEmail, sendBySMS),
    (qrCode, sendByEmail, sendBySMS) => { return { qrCode, sendByEmail, sendBySMS } },
    (dispatch, response) => {
        const transport = response.sentEmail ? "e-mail address" : "mobile number";
        dispatch(alertActions.success("An authentication code has been sent to your " + transport));
    }
);

export default sendCode;